import { Vehicle } from './../../../models/Vehicle';
import { Component, Input, OnInit } from '@angular/core';
import { BookingService } from 'src/app/services/booking.service';
import { EvaluationSummaryModel } from 'src/app/models/Evaluation/EvaluationSummaryModel';
import { EvaluationLogsMasterModel } from 'src/app/models/Evaluation/EvaluationLogsMasterModel';
import { EvaluationParmModel } from 'src/app/models/Evaluation/EvaluationParmModel';
import { EvaluationDomainTemplateScopeEnum } from 'src/app/models/enums/Evaluation/EvaluationEnums';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AuthService } from './../../../services/auth.service';
import { Customer } from 'src/app/models/Customer';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';


@Component({
  selector: 'view-reviews',
  templateUrl: './view-reviews.component.html',
  styleUrls: ['./view-reviews.component.scss']
})
export class ViewReviewsComponent implements OnInit {

  customer: Customer;

  constructor(private bookingService: BookingService, private attachmentService: AttachmentService,private authService: AuthService,) { }
  @Input() vehicle: Vehicle;
  hasReview = false;
  //Evaluation Models
  evaluationSummary: EvaluationSummaryModel;
  evaluationLogsMasterList: EvaluationLogsMasterModel[];
  ngOnInit() {
    this.authService.loggedInCustomer.subscribe(res =>{
      this.customer=res;
    })

    if (this.vehicle == null) {
      this.bookingService.vehicle.subscribe(res => {

        this.vehicle = res;
        if (res != null) {
          this.loadReviews();
        }

      });
    }
    else {
      this.loadReviews();
    }
    this.bookingService.reviewAdded.subscribe(res => {
      this.loadReviews();
    })

  }
  loadReviews() {

    if (this.vehicle != null && (this.vehicle.vehicleID != null || this.vehicle.classID || this.vehicle.makeID != null)) {
      let req: EvaluationParmModel = {
        VehicleID: this.vehicle.vehicleID,
        ClassID: this.vehicle.classID,
        MakeID: this.vehicle.makeID,
        ModelID: this.vehicle.modelID,
        Year: this.vehicle.year,
        ScopeID: EvaluationDomainTemplateScopeEnum.CustomerToRental
      }


      this.bookingService.getEvaluationSummary(req).subscribe(res => {


        if (res != null && res.evaluationLogsDetails != null && res.evaluationLogsDetails.length > 0) {
          this.hasReview = true;
        }
        this.evaluationSummary = res;
      });

      let evaluationLogsMastersReq: EvaluationParmModel = {
        VehicleID: this.vehicle.vehicleID,
        ClassID: this.vehicle.classID,
        MakeID: this.vehicle.makeID,
        ModelID: this.vehicle.modelID,
        Year: this.vehicle.year,
        ScopeID: EvaluationDomainTemplateScopeEnum.CustomerToRental
      }

      this.bookingService.getEvaluationLogsMasters(evaluationLogsMastersReq).subscribe(res => {

        this.evaluationLogsMasterList = res;
        
      });

    }

    





  }

  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }

}
